import React from "react"

import { useDnDContextState } from "shared/lib/drag-and-drop/useDnDContextState"
import { WithChildren } from "shared/types/WithChildren"
import { DragGhost } from "shared/ui/drag-ghost/DragGhost"

import { DndContext, DragOverlay } from "@dnd-kit/core"

import { DragSourceDataContext } from "./DragSourceDataContext"
import { PointerPositionContext } from "./PointerPositionContext"

export const DnDProvider = React.memo(({ children }: WithChildren) => {
  const {
    activeDragSource,
    handleDragStart,
    handleDragMove,
    handleDragEnd,
    sensors,
    collisionDetection,
    dragSourceContext,
    pointerPositionContext
  } = useDnDContextState()

  return (
    <DndContext
      onDragStart={handleDragStart}
      onDragMove={handleDragMove}
      onDragEnd={handleDragEnd}
      sensors={sensors}
      collisionDetection={collisionDetection}
    >
      <DragSourceDataContext.Provider value={dragSourceContext}>
        <PointerPositionContext.Provider value={pointerPositionContext}>
          {children}
          <DragOverlay dropAnimation={null}>
            {activeDragSource ? (
              <DragGhost text={activeDragSource.label ?? activeDragSource.id} />
            ) : null}
          </DragOverlay>
        </PointerPositionContext.Provider>
      </DragSourceDataContext.Provider>
    </DndContext>
  )
})

DnDProvider.displayName = "DnDProvider"
